import React, { PropTypes } from 'react';
import logo from '../../../assets/images/logi_logo.png';
const LoginLogo = () => {
    return(
        <div className="col-lg-7">
              &nbsp;
              <a href="/" className="login_logo"><img width="100px" src={logo}/></a>
        </div>
    );
};

export default LoginLogo;